import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { PropertyEditorActions } from '../../../actions/PropertyEditorActions';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

interface PropertyChoiceProps extends React.Props<PropertyChoice> {
    property: core.prop.Property;
    choice: core.prop.PropertyValue | null;
    customValue?: core.prop.PropertyValue | null;
}

/*
    Child of PropertyChoiceList-Component
    */
export class PropertyChoice extends BaseComponent<PropertyChoiceProps, {}> {
    public render(): JSX.Element {
        let tImg: JSX.Element | null = null;
        let tIcon: string | null = null;
        let choiceLabel: string | null = t('Different value');
        if (this.props.choice != null) {
            choiceLabel = this.props.choice.text;
            if (choiceLabel == null || choiceLabel === '') {
                choiceLabel = this.props.property.getValueAsString(this.props.choice);
            }
            if (this.props.choice.largeIcon != null && this.props.choice.largeIcon !== '') {
                tIcon = this.props.choice.largeIcon;
            }
            if (tIcon == null && this.props.choice.smallIcon != null && this.props.choice.smallIcon !== '') {
                tIcon = this.props.choice.smallIcon;
            }
            if (tIcon != null) {
                tImg = <div className="core-property-choice-img" style={{backgroundImage: 'url(\'' + tIcon + '\')'}} />;
            }    else {
                tImg = <div className="core-property-choice-radio" />;
            }
        } else {
            tImg = <div className="core-property-choice-radio" />;
            if (this.props.customValue != null) {
                let customText: string | null = this.props.customValue.text;
                if (utils.string.isNullOrEmpty(customText)) {
                    customText = this.props.property.getValueAsString(this.props.customValue);
                }
                choiceLabel = t('Different value') + ': ' + customText;
            }
        }
        let tClassName: string = 'core-property-choice';
        if (
            this.props.property.isValueEqual(this.props.choice) ||
            (
                this.props.customValue != null &&
                this.props.property.isValueEqual(this.props.customValue)
            )
        ) {
            tClassName += ' selected';
        }
        return (
            <tr className={tClassName} onClick={this.onChoiceClick}>
                <td>{tImg}</td>
                <td>{choiceLabel}{(this.props.choice == null ? <div className="core-property-choice-custom" /> : null)}</td>
            </tr>
        );
    }

    protected onChoiceClick = (pEvent: React.MouseEvent) => {
        if (this.props.choice == null) {
            VisibilityActions.setDialog({
                callback: (value: any): void => {PropertyEditorActions.setPropertyValue(this.props.property, value); },
                label: this.props.property.getName(),
                default: this.props.property.getValueAsString(),
                type: (
                    (this.props.property instanceof core.prop.NumberProperty) ||
                    (this.props.property instanceof core.prop.LengthProperty)
                ) ? 'number' : 'text'
            });
        } else {
            PropertyEditorActions.onChoiceClick(this.props.property, this.props.choice.value);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/PropertyChoice.tsx